import { FormFieldTypes } from "../../../data/formFieldType";

export const AttendanceSubmissionFormData = {
  name: "TransactionReportFormData",
  initialState: {
    organisationName: "",
    courseEventName: "",
    attendanceSubmittedDate: null,
    statusId:null
  },
  formFields: [
    {
      id: "organisationName",
      lable: "Search by Course Provider Name",
      Field_Name: "Search by Course Provider Name",
      fieldType: FormFieldTypes.INPUT,
      dataField: "organisationName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
    {
      id: "courseEventName",
      lable: "Search by Course Event",
      Field_Name: "Search by Course Event",
      fieldType: FormFieldTypes.INPUT,
      dataField: "courseEventName",
      fieldSetting: {
        placeholder: "",
        allowSpace: true,
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
    {
      id: "attendanceSubmittedDate",
      lable: "Attendance Submitted Date",
      Field_Name: "Attendance Submitted Date",
      fieldType: FormFieldTypes.DATEPICKER,
      dataField: "attendanceSubmittedDate",
      fieldSetting: {
        placeholder: "Select",
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
    {
      id: "statusId",
      lable: "Status",
      Field_Name: "Status",
      fieldType: FormFieldTypes.SELECT,
      dataField: "statusId",
      fieldSetting: {
        placeholder: "Select",
      },
      style: {
        containerCss: "col-lg-6 mb-2",
      },
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};